import { createUseStyles } from 'react-jss';

import { ThemeProps } from '@styles/theme';
import { flex, textOverflowDots } from '@resources/mixins';

export const useStyles = createUseStyles((theme: ThemeProps) => ({
    expanded: {},
    notActive: {},

    button: {
        border: 'none',
        background: 'none',
        outline: 'none',
        padding: 0,
        height: 24,
        width: 24,
        ...flex('row', 'center', 'center'),

        '&:disabled': {
            opacity: 0.3,
        },

        '&:hover': {
            background: theme.colors.icon_background,
            borderRadius: theme.radius / 2,
            cursor: 'pointer',
        },
        [theme.down('desktop')]: {
            height: 32,
            width: 32,
        },
    },

    userWrapper: {
        ...flex('row', 'flex-start', 'center'),
    },

    userNameWrapper: {
        display: 'flex',
        flexDirection: 'column',
        minWidth: 0,
        overflow: 'hidden',
    },

    userEmail: {
        fontSize: 11,
        color: theme.colors.grey_text,
        ...textOverflowDots(),
        lineHeight: 1.3,
    },

    userAvatar: {
        display: 'inline-flex',
        marginRight: theme.spacing(3),
        [theme.down('desktop')]: {
            display: 'none',
        },
    },

    moreItemsPresent: {
        // color: theme.colors.blue_link,
        // marginLeft: theme.spacing(2),
        // fontFamily: theme.font.secondary,
    },

    noInfo: {
        color: theme.colors.grey_text,
        ...textOverflowDots(),
        display: 'inherit',
    },

    capitalized: {
        textTransform: 'capitalize',
    },

    ellipsis: {
        ...textOverflowDots(),
    },

    searchPanel: {
        flex: '0 1 220px',
        maxWidth: 220,
        paddingRight: 0,
        minWidth: 160,
        [theme.down('desktop')]: {
            width: '100%',
            maxWidth: '100%',
            minWidth: 0,
            paddingRight: 0,
        },
        [theme.down('mobile')]: {
            width: 'auto',
            flex: 1,
        },
    },

    // The Users/Procedures toggle already indicates the active list on phones,
    // so the redundant section title is hidden there.
    sectionTitle: {
        [theme.down('mobile')]: {
            display: 'none',
        },
    },

    mainWrapper: {
        padding: theme.spacing(2),
        width: '100%',
        height: '100%',
        borderRight: `1.5px solid ${theme.colors.grey_light}`,
        display: 'flex',
        flexDirection: 'column',
        minWidth: 0,
        minHeight: 0,
        [theme.down('desktop')]: {
            width: '100%',
            height: 'auto',
            borderRight: 'none',
            borderBottom: `1.5px solid ${theme.colors.grey_light}`,
        },
    },

    headerWrapper: {
        minHeight: 56,
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        padding: 0,
        gap: theme.spacing(2),
        flexWrap: 'nowrap',
        [theme.down('desktop')]: {
            minHeight: 0,
            flexWrap: 'wrap',
            alignItems: 'stretch',
            padding: 0,
            marginBottom: theme.spacing(3),
        },
        [theme.down('mobile')]: {
            flexWrap: 'nowrap',
            alignItems: 'center',
        },
    },

    titleWrapper: {
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        minWidth: 0,
        gap: theme.spacing(2),
        flex: 1,
        [theme.down('desktop')]: {
            width: '100%',
            flexWrap: 'wrap',
        },
        [theme.down('mobile')]: {
            width: 'auto',
            flex: '0 0 auto',
            flexWrap: 'nowrap',
        },
    },

    memebersCounter: {
        minHeight: '30px',
        minWidth: '130px',
        background: theme.colors.surface_elevated,
        border: `1px solid ${theme.colors.grey_light}`,
        borderRadius: '5px',
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'space-evenly',
        alignContent: 'center',
        padding: '4px 10px',
        color: theme.colors.black,
        fontFamily: theme.font.secondary,
        fontSize: 14,
        [theme.down('desktop')]: {
            marginLeft: 0,
        },
    },

    tableWrapper: {
        flex: 1,
        minHeight: 0,
        width: '100%',
        overflow: 'hidden',
    },

    actionsWrapper: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-start',
        width: 96,
        gap: theme.spacing(1),
        [theme.down('desktop')]: {
            width: 88,
            justifyContent: 'flex-end',
        },
    },
}));
